import { Flex, Image, Space, Stack } from '@mantine/core';
import { useIntl } from 'react-intl';

import { LBClubCard } from '@/features/search/components/club-card';
import { NotFoundResults } from '@/features/search/components/not-found-results/NotFoundResults';
import { PageLoading } from '@/pages/PageLoading';
import { COUNTRY_LIST } from '@/shared/data/country';
import { LBSearchMultiselect } from '@/shared/ui-kit/components';

import { useArtistSearchPage } from './hooks/useArtistSearchPage';

import logo from '@/../public/logo.svg';

export const ArtistSearchPage = () => {
  const {
    data,
    state,
    functions: { navigate }
  } = useArtistSearchPage();
  const { formatMessage } = useIntl();

  if (state.isLoading) return <PageLoading />;

  return (
    <div>
      <Flex align='end' justify='space-between'>
        <Image src={logo} />
      </Flex>
      <Space h='16' />
      <LBSearchMultiselect
        searchable
        data={COUNTRY_LIST}
        placeholder={formatMessage({ id: 'form.search.placeholder' })}
        value={state.country ?? []}
        onChange={(value) => state.setCountry(value)}
      />
      <Stack gap={20} mt={20}>
        {data ? (
          data.map((item) => (
            <LBClubCard
              key={item.clubProfileId}
              data={item}
              navigate={() =>
                navigate({
                  to: '/artist/$id/profile-info/$clubId',
                  params: { clubId: item.clubProfileId.toString() }
                })
              }
            />
          ))
        ) : (
          <NotFoundResults />
        )}
      </Stack>
      <div ref={state.elementRef} />
    </div>
  );
};
